import Vue from 'vue';
import Router from 'vue-router';
// import Download from './views/Download.vue';

import Protocol from './views/Protocol.vue'; //协议
/* 硬件列表 */
import HardList from './views/Hardware/HardList.vue'; //我的硬件
import StandardNode from './views/Hardware/StandardNode.vue'; //我的硬件
import DialConfig from './views/Hardware/DialConfig.vue'; //拨号
import StandardList from './views/Hardware/StandardList.vue'; //拨号

/* 用户登陆、注册相关 */
import Login from './views/User/Login.vue';
import SignUp from './views/User/SignUp.vue';
import Forget from './views/User/Forget.vue';

/* 微信公众号页面 */
import WechatHome from './views/Wechat/Home.vue';
import WechatRevenue from './views/Wechat/WechatRevenue.vue';
import WechatDevice from './views/Wechat/WechatDevice.vue';
import UnbindWechat from './views/Wechat/UnbindWechat.vue';
import WechatDeviceStatus from './views/Wechat/WechatDeviceStatus.vue';
import NewerGuide from './views/Wechat/NewerGuide.vue';

/* 数据面板 */
import Home from './views/DataPanel/Home.vue'; //首页
import Withdrawal from './views/DataPanel/Withdrawal.vue'; //提现
import Exchange from './views/DataPanel/Exchange.vue'; //提现
import NetworkContribution from './views/DataPanel/NetworkContribution.vue'; //全网贡献 
import BuyBack from './views/DataPanel/BuyBack.vue'; //回购
import BuyBackSecond from './views/DataPanel/BuyBackSecond.vue'; //回购
import DialStatus from './views/DataPanel/DialStatus.vue'; //拨号状态

// 收益
import Revenue from './views/DataPanel/Revenue/Revenue.vue'; //收益总览
import DevAllRevenue from './views/DataPanel/Revenue/DevAllRevenue.vue'; //设备收益详情
import NetDetail from './views/DataPanel/Revenue/NetDetail.vue';
import CalculateDetail from './views/DataPanel/Revenue/CalculateDetail.vue';
import InviteDetail from './views/DataPanel/Revenue/InviteDetail.vue';

// 运行状态
import DeviceOverview from './views/DataPanel/RunStatus/DeviceOverview.vue'; //设备总览
import NetStatus from './views/DataPanel/RunStatus/NetStatus.vue'; //网络任务运行状态
import CalculateStatus from './views/DataPanel/RunStatus/CalculateStatus.vue'; //计算任务运行状态
import CalculateTask from './views/DataPanel/RunStatus/CalculateTask.vue'; //计算任务选择

/* 账号设置 */
import BindWallet from './views/AccountSet/BindWallet.vue';
import AccountSet from './views/AccountSet/AccountSet.vue'; //修改密码
import Contact from './views/AccountSet/Contact.vue'; //联系方式
import WithdrawalAuto from './views/AccountSet/WithdrawalAuto.vue'; //支付宝

/* 节点拨号 */
import NodeDial from './views/Crm/NodeDial.vue'; //
import WhiteBalance from './views/Crm/WhiteBalance.vue'; //
import NewServer from './views/Crm/NewServer.vue'; //
import WhiteList from './views/Crm/WhiteList.vue'; //
import BlackList from './views/Crm/BlackList.vue'; //
import Config from './views/Crm/Config.vue'; //
import SendBcode from './views/Crm/SendBcode.vue'; //
import AutoWithUser from './views/Crm/AutoWithUser.vue'; //
import AutoWithOrder from './views/Crm/AutoWithOrder.vue'; //
import Balance from './views/Crm/Balance.vue'; //
import WithOrderList from './views/Crm/WithOrderList.vue'; //

/* 标准节点 */
import StandardStatus from './views/DataPanel/Standard/StandardStatus.vue'; //
import StandardWatch from './views/DataPanel/Standard/StandardWatch.vue'; //

import Info from './views/Info.vue'; //

Vue.use(Router);

// import { getCookie } from "@/utils/utils";
// let language = getCookie("NEW_BASIC_LANUAGE");
import { isZnWebsite } from './utils/isChinaWebsite';
const title = isZnWebsite ? '博纳云：全球泛载雾计算平台' : 'BonusCloud: The Worldwide Universally-carried Fog Computing Platform';

let routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      title,
    },
    component: Home,
  },
  // {
  //   path: '/download',
  //   name: 'download',
  //   meta: {
  //     title,
  //   },
  //   component: Download,
  // },
  {
    path: '/revenue',
    name: 'revenue',
    meta: {
      title,
    },
    component: Revenue,
  },
  {
    path: '/inviteDetail',
    name: 'inviteDetail',
    meta: {
      title,
    },
    component: InviteDetail,
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      title,
    },
    component: Login,
  },
  {
    path: '/signUp',
    name: 'signUp',
    meta: {
      title,
    },
    component: SignUp,
  },
  {
    path: '/forget',
    name: 'forget',
    meta: {
      title,
    },
    component: Forget,
  },
  {
    path: '/AccountSet',
    name: 'accountSet',
    meta: {
      title,
    },
    component: AccountSet,
  },
  {
    path: '/hardList',
    name: 'hardList',
    meta: {
      title,
    },
    component: HardList,
  },
  {
    path: '/bindWallet',
    name: 'bindWallet',
    meta: {
      title,
    },
    component: BindWallet,
  },
  {
    path: '/exchange',
    name: 'exchange',
    meta: {
      title,
    },
    component: Exchange,
  },
  {
    path: '/protocol',
    name: 'Protocol',
    meta: {
      title,
    },
    component: Protocol,
  },
  {
    path: '/netStatus',
    name: 'netStatus',
    meta: {
      title,
    },
    component: NetStatus,
  },
  {
    path: '/netDetail',
    name: 'netDetail',
    meta: {
      title,
    },
    component: NetDetail,
  },
  {
    path: '/calculateDetail',
    name: 'calculateDetail',
    meta: {
      title,
    },
    component: CalculateDetail,
  },
  {
    path: '/devAllRevenue',
    name: 'devAllRevenue',
    meta: {
      title,
    },
    component: DevAllRevenue,
  },
  {
    path: '/calculateStatus',
    name: 'calculateStatus',
    meta: {
      title,
    },
    component: CalculateStatus,
  },
  {
    path: '/calculateTask',
    name: 'calculateTask',
    meta: {
      title,
    },
    component: CalculateTask,
  },
  {
    path: '/networkContribution',
    name: 'networkContribution',
    meta: {
      title,
    },
    component: NetworkContribution,
  },
  {
    path: '/deviceOverview',
    name: 'deviceOverview',
    meta: {
      title,
    },
    component: DeviceOverview,
  },
  {
    path: '/wechat',
    name: 'Wechat',
    meta: {
      title,
    },
    component: WechatHome,
  },
  {
    path: '/wechat/unbind',
    name: 'UnbindWechat',
    meta: {
      title,
    },
    component: UnbindWechat,
  },
  {
    path: '/wechat/revenue',
    name: 'WechatRevenue',
    meta: {
      title,
    },
    component: WechatRevenue,
  },
  {
    path: '/wechat/device',
    name: 'WechatDevice',
    meta: {
      title,
    },
    component: WechatDevice,
  },
  {
    path: '/wechat/deviceStatus',
    name: 'WechatDeviceStatus',
    meta: {
      title,
    },
    component: WechatDeviceStatus,
  },
  {
    path: '/standardNode',
    name: 'StandardNode',
    meta: {
      title,
    },
    component: StandardNode,
  },
  {
    path: '/dialConfig',
    name: 'DialConfig',
    meta: {
      title,
    },
    component: DialConfig,
  },
  {
    path: '/crm/node',
    name: 'nodeDial',
    meta: {
      title,
    },
    component: NodeDial,
  },
  {
    path: '/crm/config',
    name: 'Config',
    meta: {
      title,
    },
    component: Config,
  },
  {
    path: '/crm/whiteList',
    name: 'WhiteList',
    meta: {
      title,
    },
    component: WhiteList,
  },
  {
    path: '/crm/blackList',
    name: 'BlackList',
    meta: {
      title,
    },
    component: BlackList,
  },
  {
    path: '/crm/server',
    name: 'Server',
    meta: {
      title,
    },
    component: NewServer,
  },
  {
    path: '/crm/whiteBalance',
    name: 'WhiteBalance',
    meta: {
      title,
    },
    component: WhiteBalance,
  },
  {
    path: '/crm/sendBcode',
    name: 'SendBcode',
    meta: {
      title,
    },
    component: SendBcode,
  },
  {
    path: '/crm/autoWithUser',
    name: 'AutoWithUser',
    meta: {
      title,
    },
    component: AutoWithUser,
  },
  {
    path: '/crm/autoWithOrder',
    name: 'AutoWithOrder',
    meta: {
      title,
    },
    component: AutoWithOrder,
  },
  {
    path: '/crm/withOrderList',
    name: 'WithOrderList',
    meta: {
      title,
    },
    component: WithOrderList,
  },
  {
    path: '/crm/balance',
    name: 'Balance',
    meta: {
      title,
    },
    component: Balance,
  },
  {
    path: '/standardList',
    name: 'StandardList',
    meta: {
      title,
    },
    component: StandardList,
  },
];

// 英文
if (isZnWebsite) {
  routes.push(
    {
      path: '/dialStatus',
      name: 'DialStatus',
      meta: {
        title,
      },
      component: DialStatus,
    },
    {
      path: '/standardStatus',
      name: 'StandardStatus',
      meta: {
        title,
      },
      component: StandardStatus,
    },
    {
      path: '/standardWatch',
      name: 'StandardWatch',
      meta: {
        title,
      },
      component: StandardWatch,
    },
    {
      path: '/buyBack',
      name: 'BuyBack',
      meta: {
        title,
      },
      component: BuyBack,
    },
    {
      path: '/buyBackSecond',
      name: 'BuyBackSecond',
      meta: {
        title,
      },
      component: BuyBackSecond,
    },
    {
      path: '/contact',
      name: 'Contact',
      meta: {
        title,
      },
      component: Contact,
    },
    {
      path: '/withdrawalAuto',
      name: 'WithdrawalAuto',
      meta: {
        title,
      },
      component: WithdrawalAuto,
    },
    {
      path: '/newerGuide',
      name: 'NewerGuide',
      meta: {
        title,
      },
      component: NewerGuide,
    },
    {
      path: '/info',
      name: 'Info',
      meta: {
        title,
      },
      component: Info,
    },
  )
} else {
  // 英文
  routes.push(
  {
    path: '/withdrawal',
    name: 'withdrawal',
    meta: {
      title,
    },
    component: Withdrawal,
  });
}



export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});
